import React from "react"
import { v4 as uuidv4 } from "uuid"
import { SearchspringSearchResult } from "@app/types"

export const storeFrontAccessToken = "602f8b5dec7379dba72615f89a17cc6a"

export function generateId() {
  return uuidv4()
}

export const parseIfString = (input) => {
  if (typeof input === "string") {
    try {
      return JSON.parse(input.replace(/&quot;/g, '"'))
    } catch {
      return []
    }
  }
  return input || []
}

export const isMobile = window.innerWidth < 768

// Gets the current country currency from Shopify data or defaults to AUD
export const currentCountryCurrency =
  typeof window !== "undefined" &&
  window.SHOPIFY_DATA &&
  window.SHOPIFY_DATA.currency
    ? window.SHOPIFY_DATA.currency
    : { countryCode: "AU", currencyCode: "AUD", currencySymbol: "$" }

export function stripHTML(html: string): string {
  const tempDiv = document.createElement("div")
  tempDiv.innerHTML = html
  return tempDiv.textContent || ""
}

export function decodeHTMLEntities(text: string): string {
  const tempDiv = document.createElement("div")
  tempDiv.innerHTML = text
  return tempDiv.textContent || text
}

// Product Utils
export function useProductBadge(
  data: SearchspringSearchResult,
  available: boolean
) {
  if (!data?.tags?.length) return ""

  const tagBadges = data.tags
    ?.filter((tag: string) => tag?.toLowerCase()?.includes("badge:"))
    ?.map((tag: string) => tag.split("badge:")[1].trim().toLowerCase())

  const preorderBadge = tagBadges.includes("pre-order")
  const customBadge = tagBadges.find(
    (b: string) => b !== "pre-order" && b !== "out of stock" && b !== "sale"
  )

  if (preorderBadge) {
    return <span className="badge pre-order">Pre Order</span>
  } else if (!available) {
    return <span className="badge out-of-stock">Out of Stock</span>
  } else if (data?.msrp > data?.price && available) {
    return <span className="badge on-sale">Sale</span>
  } else if (customBadge) {
    const handle = customBadge?.replace(/\s+/g, "-").toLowerCase()
    return (
      <div className={`badge ${handle}`} data-badge={handle}>
        {customBadge}
      </div>
    )
  }

  return ""
}

// sanitizes strings to replace all spaces, slashes and underscores with a dash
export function normalizeHandleDash(input: string) {
  // check if handle starts with underscore and then removes it
  // This is connected to a colour swatch graphql alias issue
  if (input.startsWith("_")) {
    input = input.slice(1)
  }

  return input.toLowerCase().replace(/[\s/_]+/g, "-")
}

export async function fetchStorefront(query: string) {
  const endpoint = `https://${Shopify.shop}/api/2025-04/graphql.json`
  const res = await fetch(endpoint, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Shopify-Storefront-Access-Token": storeFrontAccessToken,
    },
    body: JSON.stringify({ query }),
  })
  const { data, errors } = await res.json()
  if (errors) {
    console.error("Storefront GraphQL errors:", errors)
    throw new Error(errors.map((e: string) => e.message).join("\n"))
  }
  return data
}
